import styled from "@emotion/styled";

const List = styled.ul`
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  margin: 0;
  padding: 0;
  list-style: none;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.space[3]}px;
  padding: ${p => p.theme.space[3]}px 6px;
`;

const Item = styled.li``;

const Button = styled.button`
  width: 100%;
  border-radius: ${p => p.theme.space[3]}px;
  padding: ${p => p.theme.space[3]}px ${p => p.theme.space[4]}px;

  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: ${p => p.theme.space[5]}px;
  font-family: inherit;
  display: inline-flex;
  gap: 6px;
  align-items: center;

  &:focus {
    background-color: ${p => p.theme.colors.background};
  }

  &:hover {
    background-color: ${p => p.theme.colors.background};
  }
`;

const IconBox = styled.span`
  display: none;
  @media (min-width: ${p => p.theme.screenSizes.mdMin}) {
    display: flex;
  }
`;

export { List, Item, Button, IconBox };
